import { api } from "../client";
import {
  CommissionAttribute,
  PartialCommissionAttribute,
} from "../schema/CommissionAttribute";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<CommissionAttribute>;
type ApiRequestConfigMutate = ConfigMutate<PartialCommissionAttribute>;

export const getCommissionAttributes = async (config?: ApiRequestConfig) => {
  return api.get<CommissionAttribute>("commission_attributes", config);
};
export const getCommissionAttribute = (
  id: number,
  config?: ApiRequestConfig
) => {
  return api.get<CommissionAttribute>(`commission_attributes/${id}`, config);
};

export const createCommissionAttribute = (config: ApiRequestConfigMutate) => {
  return api.create<PartialCommissionAttribute, {}>(
    "commission_attributes",
    config
  );
};
export const updateCommissionAttribute = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialCommissionAttribute, {}>(
    `commission_attributes/${id}`,
    config
  );
};
export const deleteCommissionAttribute = (id: number) => {
  return api.remove<CommissionAttribute, {}>(`commission_attributes/${id}`);
};
